import { BrowserRouter, Route, Routes } from "react-router-dom";
// public
import Tracking from "../screens/tracking";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:trackingId" element={<Tracking />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
